import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import CompanyIssuerForm from './CompanyIssuerForm';
import CompanyIssuerList from './CompanyIssuerList';
import { getCompany } from '../../../services/apiservice';
import { useAuth } from '../../../contexts/authContext';
import { useApiData } from '../../../hooks/useApi';

function ManageCompanyIssuers() {
  const { user } = useAuth();
  const issuerID = user.IssuerID;
  const companyID = user.IssuerCompanyID;
  const [tabIndex, setTabIndex] = useState(0);
  const [showMoreDetails, setShowMoreDetails] = useState(false);
  const [companyDetails, setCompanyDetails] = useState(null);
  const { data: fetchedCompanyDetails } = useApiData(() => getCompany(companyID).then((res) => res.data), []);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  useEffect(() => {
    if (fetchedCompanyDetails) {
      setCompanyDetails(fetchedCompanyDetails);
    }
  }, [fetchedCompanyDetails]);

  return (
    <Box sx={{ width: '100%', overflowX: 'auto' }}>
      <Helmet>
        <title>Manage Issuers</title>
      </Helmet>
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        textColor="primary"
        indicatorColor="primary"
        sx={{ ml: 4 }}
        TabIndicatorProps={{ sx: { width: 'auto' } }}
      >
        <Tab label="Manage Issuers" sx={{ minWidth: "auto", px: 2 }} />
        <Tab label="Create Issuer" sx={{ minWidth: "auto", px: 2 }} />
      </Tabs>

      {tabIndex === 0 && (
        <Box p={3}>
          <CompanyIssuerList />
        </Box>
      )}

      {tabIndex === 1 && (
        <Box p={3}>
          <CompanyIssuerForm companyDetails={companyDetails} />
        </Box>
      )}
    </Box>
  );
}

export default ManageCompanyIssuers;
